import PropTypes from "prop-types";

const GenericContentCard = ({
  children,
  noPadding = false,
  withBackground = false,
  fullScreen = false,
}) => {
  return (
    <div
      className={`${fullScreen ? "h-screen" : "h-full"} ${noPadding ? "" : "p-5"} flex-grow gap-3 flex flex-col card-base bg-white ${withBackground ? "card-base-background" : ""} card-base-border overflow-hidden`}
    >
      {children}
    </div>
  );
};

GenericContentCard.propTypes = {
  children: PropTypes.node.isRequired,
  noPadding: PropTypes.bool,
  withBackground: PropTypes.bool,
  fullScreen: PropTypes.bool,
};

export default GenericContentCard;
